import { Component } from 'vue-property-decorator';
import ItiScheduledTaskForm from './../form/iti-scheduled-task-form.vue';
import Vue from 'vue';
import { ItiIconButton, ItiVHeader, ItiScheduledTask } from '@/iti-core-vuetify';
import { itiScheduledTasksModule } from '@/store';
import { itiMessageService } from '@/iti-core-vue';

@Component({
  components: {
    ItiScheduledTaskForm,
    ItiIconButton
  },
})
export default class ItiScheduledTasksList extends Vue {

  public addHidden = true;
  public loading = false;
  public search = '';
  public showDialog = false;

  public modalComponent: string | null = null;

  // Definimos las columnas del grid
  public get headers() {
    return [
      new ItiVHeader('name', 'nombre'),
      new ItiVHeader('identifier', 'maestro-tareas.tipo-tarea'),
      new ItiVHeader('cron', 'maestro-tareas.cron'),
      new ItiVHeader('isRunning', 'maestro-tareas.en-ejecucion').withWidth(100),
      new ItiVHeader('isActive', 'maestro-tareas.inicio-automatico').withWidth(100),
      new ItiVHeader('action', '').withSortable(false).withWidth(250),
    ];
  }

  public get dataHeaders() {
    return this.headers.filter((column) => column.text != null && column.text.length > 0);
  }

  public get items(): ItiScheduledTask[] {
    return itiScheduledTasksModule.tasks;
  }

  public created() {
    itiScheduledTasksModule.refreshTasks();
  }

  public mounted() {
    // En 0,5 segundos mostramos el botón de añadir para que haga una animáción visible
    setTimeout(() => {
      this.addHidden = false;
    }, 500);
  }

  public newItem() {
    this.openFormulario();
  }

  public editItem(item: ItiScheduledTask) {
    this.openFormulario(item);
  }

  public deleteItem(item: ItiScheduledTask) {
    itiMessageService.confirm(
      this.$tc('mensajes.pregunta-borrar') + item.Name + '" ?', this.$tc('mensajes.confirmar'),
      (res) => {
        if (res) {
          itiScheduledTasksModule.deleteTask(item);
        }
      },
    );
  }

  public closeFormulario(item: any) {
    this.showDialog = false;
    this.modalComponent = null;
  }

  public start(item: any) {
    itiScheduledTasksModule.startTask(item);
  }

  public stop(item: any) {
    itiScheduledTasksModule.stopTask(item);
  }

  protected openFormulario(item: ItiScheduledTask | null = null) {
    itiScheduledTasksModule.setTask(item === null ? new ItiScheduledTask() : item);
    this.modalComponent = 'ItiScheduledTaskForm';
    this.showDialog = true;
  }

}